import { Chip, Typography } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { capitalize } from 'lodash';
import type { FieldPath } from 'react-hook-form';
import { CancelInvitationButton } from './CancelInvitationButton';
import { UserInvitation } from '@vy/types';

export const INVITATIONS_KEYS = Object.freeze({
  NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  STATUS: 'status',
  ROLE: 'role',
  ACTIONS: 'actions',
} satisfies Record<string, FieldPath<UserInvitation> | 'actions'>);

export const INVITATIONS_COLUMNS: GridColDef<UserInvitation>[] = [
  {
    field: INVITATIONS_KEYS.NAME,
    headerName: 'First Name',
    sortable: false,
    renderCell: ({ row }) => <Typography noWrap>{row.firstName ?? '--'}</Typography>,
  },
  {
    field: INVITATIONS_KEYS.LAST_NAME,
    headerName: 'Last Name',
    sortable: false,
    renderCell: ({ row }) => <Typography noWrap>{row.lastName ?? '--'}</Typography>,
  },
  {
    field: INVITATIONS_KEYS.EMAIL,
    headerName: 'Email',
    sortable: false,
    renderCell: ({ row }) => <Typography noWrap>{row.email}</Typography>,
  },
  {
    field: INVITATIONS_KEYS.STATUS,
    headerName: 'Status',
    sortable: false,
    renderCell: () => <Chip label="Waiting" color="warning" size="small" variant="outlined" />,
  },
  {
    field: INVITATIONS_KEYS.ROLE,
    headerName: 'Role',
    sortable: false,
    maxWidth: 180,
    valueGetter: (_value, row) => capitalize(row.role),
    renderCell: ({ row }) => <Typography noWrap>{capitalize(row.role)}</Typography>,
  },
  {
    field: INVITATIONS_KEYS.ACTIONS,
    headerName: '',
    sortable: false,
    renderCell: ({ row }) => <CancelInvitationButton invitationId={row.id} userEmail={row.email} />,
  },
];
